export const shopRoutes = [
    {
        path: '/restaurant',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/home'));
            reject(error);
        }),
    },
    {
        path: '/restaurant/signup',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/Signup'));
            reject(error);
        }),
    },
    {
        path: '/restaurant/dashboard',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/Dashboard'));
            reject(error);
        }),
    },
    {
        path: '/restaurant/login',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/login'));
            reject(error);
        }),
    },
    {
        path: '/restaurant/edit-profile',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/EditProfile'));
            reject(error);
        }),
    },
    {
        path: '/restaurant/document',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/Document'));
            reject(error);
        }),
    },
    {
        path: '/restaurant/password',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/changePassword'));
            reject(error);
        }),
    },
    {
        path: '/restaurant/addPayout',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/Payout/AddPayout'));
            reject(error);
        }),
    },
    {
        path: '/restaurant/payout/failure',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/Payout/FailedPayout'));
            reject(error);
        }),
    },
    {
        path: '/restaurant/operating-hours',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/operationHours'));
            reject(error);
        }),
    },
    {
        path: '/restaurant/menu',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/category'));
            reject(error);
        }),
    },
    {
        path: '/restaurant/menu/add',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/addMenu'));
            reject(error);
        }),
    },
    {
        path: '/restaurant/menu/edit/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/editMenu'));
            reject(error);
        }),
    },
    {
        path: '/restaurant/menu/:id/item',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/item'));
            reject(error);
        }),
    },
    {
        path: '/restaurant/preparation-time',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/preparationTime'));
            reject(error);
        }),
    },
    {
        path: '/restaurant/order-management/:type',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/orderManageContainer'));
            reject(error);
        }),
    },
    {
        path: '/restaurant/order-details/:type/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/orderDetails'));
            reject(error);
        }),
    },
    {
        path: '/restaurant/transaction/:type',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/transaction'));
            reject(error);
        }),
    },
    {
        path: '/password/verification',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/changePasswordUsingToken/'));
            reject(error);
        }),
    },
    {
        path: '/restaurant/menu/modifier-groups',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/modifierGroups'));
            reject(error);
        }),
    },
    {
        path: '/restaurant/menu/modifier-groups/add',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/addModifierGroups'));
            reject(error);
        }),
    },
    {
        path: '/restaurant/menu/modifier-groups/edit/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/editModifierGroups'));
            reject(error);
        }),
    },
    {
        path: '/restaurant/menu/:menuId/item/:subMenuId/add',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/addFoodItem'));
            reject(error);
        }),
    },
    {
        path: '/restaurant/menu/:menuId/item/:subMenuId/edit/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/editFoodItem'));
            reject(error);
        }),
    },
    {
        path: '/restaurant/Eater-receipt-details/:type/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/eaterReceiptDetails'));
            reject(error);
        }),
    },
];